module.exports = __webpack_public_path__ + "static/media/gwp_60y_n-1.b5576a93.csv";